/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ShareLinkDialog, captureException } from '@playbookux/playbook-web-core';
import { updateProjectShareLink } from '../project/graphql';
import { config } from '../../../../../config';

const ShareProjectDialog = (props) => {
  const { project, show, handleClose } = props;
  const [loading, setLoading] = useState(false);

  if (!project) {
    return null;
  }

  const {
    id,
    name,
    sharePassword,
    shareCode,
    shareEnabled,
  } = project;

  const uri = `${config.REACT_APP_PLATFORM_URI}/share/project/${shareCode}`;

  const handleUpdate = async (password, enableShare) => {
    setLoading(true);

    try {
      await updateProjectShareLink(id, password, enableShare);
    } catch (err) {
      captureException('UPDATE_PROJECT_SHARE_LINK_FAILURE', err);
    }

    setLoading(false);
  };

  return (
    <ShareLinkDialog
      title={`Share ${name}`}
      uri={uri}
      shareEnabled={shareEnabled}
      sharePassword={sharePassword}
      loading={loading}
      toggleLabel="Enable project sharing"
      show={show}
      handleClose={handleClose}
      handleUpdate={handleUpdate}
    />
  );
};

ShareProjectDialog.defaultProps = {
  project: null,
};

ShareProjectDialog.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    sharePassword: PropTypes.string,
    shareEnabled: PropTypes.bool,
    shareCode: PropTypes.string,
  }),
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default ShareProjectDialog;
